import React from "react";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import DataGrid, {
  Column,
  Editing,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import apiAxios from "../../api-axios.js";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";
import { Button } from "devextreme-react";
import Memoria from "../../Memoria";
import notify from "devextreme/ui/notify";

let _cancelando = false;

export default class PermissoesBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarioInfo: {},
      dadosGrid: {},
    };
    this._gridInstance = React.createRef();
    this.onSelecionado = props.onSelecionado;
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);

    this.permissoesOptions = [
      { id: 0, descricao: "Padrão" },
      { id: 1, descricao: "Liberado" },
      { id: 2, descricao: "Bloqueado" },
    ];

    this.onSaving = this.onSaving.bind(this);
  }

  async componentDidMount() {
    if (this.props.location.state == undefined) {
      this.props.history.push("/usuarios-prefeitura");
    }

    const response = await apiAxios.get(
      "recursos_seguranca/permissoes_usuario/" + this.props.location.state.usuarioId
    );

    this.setState({
      ...this.state,
      dadosGrid: response.data,
      usuarioInfo: this.props.location.state,
    });
  }

  onSaving(e) {

  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form
              id="formPermissoes"
              colCount={2}
              labelLocation={"top"}
              readOnly={true}
              formData={this.state.usuarioInfo}
            >
              <SimpleItem dataField="usuarioNome" colSpan={1} disabled={true}>
                <Label text="Nome" />
              </SimpleItem>
              <SimpleItem dataField="cpfCnpj" colSpan={1} disabled={true}>
                <Label text="Documento" />
              </SimpleItem>
            </Form>
            <br />
            <br />
            <br />
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.dadosGrid}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              columnAutoWidth={true}
              onInitNewRow={this.initNewRow}
              onEditCanceled={e => console.log(e)}

            >
              <Editing mode={"batch"} allowUpdating={true} useIcons={true} />

              <Column dataField={"id"} caption={"ID"} alignment={"center"} width={"100"} allowEditing={false} />

              <Column
                dataField={"permitido"}
                allowEditing={false}
                alignment={"center"}
                customizeText={(cellInfo) => (cellInfo.value ? "Sim" : "Não")}
                dataType="text"
                width={100}
              />

              <Column
                dataField={"nome"}
                allowEditing={false}
                width={"50%"}
              />

              <Column
                dataField={"origem"}
                allowEditing={false}
                width={"50%"}
              />
              <Column
                dataField={"permissao"}
                allowEditing={true}
                alignment={"center"}
                width={130}
              >
                <Lookup
                  dataSource={this.permissoesOptions}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>

            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment >
    );
  }

  async ok() {

    if (this._gridInstance.instance.hasEditData()) {
      this._gridInstance.instance.saveEditData();
    }

    const entidade = this.state.dadosGrid;

    const response = await apiAxios.post(
      "recursos_seguranca/permissoes_usuario/" + this.state.usuarioInfo.usuarioId,
      entidade
    );

    if (response) notify("Permissões alteradas!", "success");
    else notify("Erro ao alterar permissões!", "error");
  }

  cancel() {
    notify("Operação cancelada", "warning");
    /* Memoria.removerEdicao(this.props.location); */
    this.props.history.goBack();
  }
}
